import React from 'react';
import { Box, Container, Typography, Button, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from '../components/Layout';
import HeroCarousel from '../components/HeroCarousel';
import cadHero11 from '../assets/CAD_Pictures/real_baustelle/11.jpg';
import cadHero1 from '../assets/CAD_Pictures/real_baustelle/1.jpg';
import cadHero5 from '../assets/CAD_Pictures/real_baustelle/5.jpg';
import cadHero3 from '../assets/CAD_Pictures/real_baustelle/3.jpg';
import cadHero8 from '../assets/CAD_Pictures/real_baustelle/8.jpg';
import cadHero6 from '../assets/CAD_Pictures/real_baustelle/6.jpg';
import sketchupLogo from '../pics/softwares-logos/SketchUp-logo.png';
import revitLogo from '../pics/softwares-logos/revit-ft.png';
import allplanLogo from '../pics/softwares-logos/allplan.png';
import vectorworksLogo from '../pics/softwares-logos/vectorworks.png';
import archicadLogo from '../pics/softwares-logos/archicad.png';
import chiefarchitectLogo from '../pics/softwares-logos/chiefarchitect.png';
import './CADServices.css';
function CADServices() {
  const heroSlides = [
    {
      image: cadHero11,
      label: 'Stahlbau',
      eyebrow: 'Konstruktion',
      title: 'Stahlbau- und Metallbauplanung',
      description: 'Präzise Stahlkonstruktionen für anspruchsvolle Projekte.',
      animation: 'rise',
      ctaText: 'Projekt starten',
      ctaHref: '/contact'
    },
    {
      image: cadHero1,
      label: 'Metallbau',
      eyebrow: 'Fertigung',
      title: 'Fertigungsgerechte Detailplanung',
      description: 'Vom 3D-Modell bis zur Werkstattzeichnung.',
      animation: 'slide-left',
      ctaText: 'Projekt starten',
      ctaHref: '/contact'
    },
    {
      image: cadHero5,
      label: 'Rohrleitungen',
      eyebrow: 'Anlagenbau',
      title: 'Rohrleitungsplanung',
      description: 'Intelligente Rohrleitungsplanung für industrielle Anlagen.',
      animation: 'zoom',
      ctaText: 'Projekt starten',
      ctaHref: '/contact'
    },
    {
      image: cadHero3,
      label: 'Anlagenbau',
      eyebrow: 'Industrieplanung',
      title: 'Industrielle Anlagenplanung',
      description: 'Komplexe Anlagen mit höchster Präzision geplant.',
      animation: 'slide-right',
      ctaText: 'Projekt starten',
      ctaHref: '/contact'
    }
  ];

  const services = [
    {
      title: '2D Technische Zeichnungen',
      description: 'Detaillierte Grundrisse, Ansichten, Schnitte und Konstruktionsdetails nach höchsten Standards erstellt.',
      image: cadHero1
    },
    {
      title: '3D-Modellierung',
      description: 'Fortgeschrittene 3D-Modelle für Visualisierung, Koordination und Kollisionserkennung während des gesamten Planungsprozesses.',
      image: cadHero3
    },
    {
      title: 'BIM-Dienstleistungen',
      description: 'Building Information Modeling für umfassendes Projektmanagement und Koordination.',
      image: cadHero8
    },
    {
      title: 'Bestandsdokumentation',
      description: 'Präzise Dokumentation bestehender Zustände und Umbauten.',
      image: cadHero6
    },
    {
      title: 'Rendering & Visualisierung',
      description: 'Fotorealistische Renderings und Animationen zur Präsentation Ihrer Entwürfe.',
      image: cadHero5
    },
    {
      title: 'Baubewilligungspläne',
      description: 'Vollständige Plansets für Baubewilligungen gemäss den geltenden Bauvorschriften.',
      image: cadHero11
    }
  ];

  return (
    <Layout>
      {/* Full-width Hero Section */}
      <HeroCarousel
        className='cad-hero-section'
        slides={heroSlides}
        interval={9500}
        indicatorPosition='bottom-left'
        showActiveLabel={false}
        showSlideCaptions
        captionAlignment='center'
      />

      {/* Our CAD Expertise Section */}
      <Box sx={{ py: { xs: 4, md: 6 }, backgroundColor: '#fff' }}>
        <Container maxWidth='xl'>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: { xs: 6, md: 8, lg: 10 }
            }}>
            {/* Image Column */}
            <Box sx={{ flex: '1', width: '100%', maxWidth: { md: '50%' } }}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}>
                <Box
                  component='img'
                  src={cadHero11}
                  alt='CAD Services'
                  sx={{
                    width: '100%',
                    height: { xs: '300px', sm: '400px', md: '550px' },
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block'
                  }}
                />
              </motion.div>
            </Box>

            {/* Content Column */}
            <Box sx={{ flex: '1', width: '100%', maxWidth: { md: '50%' }, pl: { md: 4, lg: 6 } }}>
              <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                <Typography
                  variant='overline'
                  sx={{
                    color: '#999',
                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                    letterSpacing: '3px',
                    fontWeight: 500,
                    mb: 2.5,
                    display: 'block',
                    textTransform: 'uppercase'
                  }}>
                  PRÄZISION & FACHKOMPETENZ
                </Typography>
                <Typography
                  variant='h2'
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.5rem', lg: '2.75rem' },
                    mb: 4,
                    lineHeight: 1.3,
                    color: '#1a1a1a'
                  }}>
                  Unsere CAD-Kompetenz
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    lineHeight: 1.9,
                    color: '#6b6b6b',
                    fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                    mb: 3,
                    fontWeight: 400
                  }}>
                  Wir bieten umfassende CAD-Dienstleistungen für Architektur- und Bauprojekte und liefern präzise, detaillierte technische
                  Zeichnungen, die Ihre Vision zum Leben erwecken. Unser Team nutzt modernste Software, um Höchstmass an Genauigkeit und
                  Effizienz in jedem Projekt zu gewährleisten.
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    lineHeight: 1.9,
                    color: '#6b6b6b',
                    fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                    fontWeight: 400
                  }}>
                  Vom ersten Konzeptentwurf bis zu detaillierten Ausführungsplänen übernehmen wir alle Aspekte der CAD-Planung und -Modellierung
                  mit Professionalität und Liebe zum Detail.
                </Typography>
              </motion.div>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Services Section */}
      <Box sx={{ py: { xs: 4, md: 6 }, backgroundColor: '#f9f9f9' }}>
        <Container maxWidth='lg'>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <Divider
              sx={{
                width: '80px',
                height: '3px',
                backgroundColor: '#1a1a1a',
                margin: '0 auto 3rem',
                border: 'none'
              }}
            />
            <Typography
              variant='h2'
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.5rem' },
                mb: 4,
                textAlign: 'center',
                color: '#1a1a1a'
              }}>
              Unsere Leistungen
            </Typography>
          </motion.div>

          {/* Services Grid - Alternating Layout */}
          {services.map((service, index) => {
            const isEven = index % 2 === 0;
            return (
              <Box
                key={index}
                sx={{
                  mb: { xs: 5, md: 7 },
                  display: 'flex',
                  flexDirection: { xs: 'column', md: isEven ? 'row' : 'row-reverse' },
                  alignItems: 'center',
                  gap: { xs: 4, md: 6, lg: 8 }
                }}>
                {/* Image */}
                <Box sx={{ flex: '1', width: '100%', maxWidth: { md: '50%' } }}>
                  <motion.div
                    initial={{ opacity: 0, x: isEven ? -30 : 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}>
                    <Box
                      component='img'
                      src={service.image}
                      alt={service.title}
                      sx={{
                        width: '100%',
                        height: { xs: '220px', sm: '280px', md: '320px' },
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        '&:hover': {
                          transform: 'scale(1.02)',
                          boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
                        }
                      }}
                    />
                  </motion.div>
                </Box>

                {/* Content */}
                <Box
                  sx={{
                    flex: '1',
                    width: '100%',
                    maxWidth: { md: '50%' },
                    pl: { md: isEven ? 0 : 4 },
                    pr: { md: isEven ? 4 : 0 }
                  }}>
                  <motion.div
                    initial={{ opacity: 0, x: isEven ? 30 : -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}>
                    <Typography
                      variant='h4'
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                        mb: 2,
                        color: '#1a1a1a'
                      }}>
                      {service.title}
                    </Typography>
                    <Typography
                      variant='body1'
                      sx={{
                        lineHeight: 1.8,
                        color: '#6b6b6b',
                        fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' }
                      }}>
                      {service.description}
                    </Typography>
                  </motion.div>
                </Box>
              </Box>
            );
          })}
        </Container>
      </Box>

      {/* Praxisorientierte CAD Planung Section */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#fff' }}>
        <Container maxWidth='md'>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}>
            <Typography
              variant='overline'
              sx={{
                color: '#999',
                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                letterSpacing: '3px',
                fontWeight: 500,
                mb: 2.5,
                display: 'block',
                textTransform: 'uppercase',
                textAlign: 'center'
              }}>
              PRAXIS & ERFAHRUNG
            </Typography>
            <Typography
              variant='h2'
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.5rem', lg: '2.75rem' },
                mb: 4,
                lineHeight: 1.3,
                color: '#1a1a1a',
                textAlign: 'center'
              }}>
              Praxisorientierte CAD Planung
            </Typography>
            <Typography
              variant='body1'
              sx={{
                lineHeight: 1.9,
                color: '#6b6b6b',
                fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                fontWeight: 400,
                textAlign: 'center'
              }}>
              Wir verbinden technisches Verständnis, langjährige Erfahrung und moderne CAD Technologie, um Zeichnungen zu erstellen, die in der Praxis funktionieren – in der Werkstatt, auf der Baustelle und im Betrieb. Unser Fokus liegt nicht auf Theorie, sondern auf klaren, verständlichen und ausführbaren Plänen.
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* COMMENTED OUT: 3D Software Compatibility Section
      <Box sx={{ py: { xs: 4, md: 6 }, backgroundColor: '#fff' }}>
        <Container maxWidth='xl'>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: { xs: 4, md: 6, lg: 8 }
            }}>
            <Box sx={{ flex: '1', width: '100%', maxWidth: { md: '50%' } }}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}>
                <Typography
                  variant='overline'
                  sx={{
                    color: '#999',
                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                    letterSpacing: '3px',
                    fontWeight: 500,
                    mb: 2.5,
                    display: 'block',
                    textTransform: 'uppercase'
                  }}>
                  FLEXIBEL
                </Typography>
                <Typography
                  variant='h2'
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.5rem', lg: '2.75rem' },
                    mb: 4,
                    lineHeight: 1.3,
                    color: '#1a1a1a'
                  }}>
                  Rendern aus jeder 3D-Anwendung
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    lineHeight: 1.9,
                    color: '#6b6b6b',
                    fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                    fontWeight: 400
                  }}>
                  Mit dem flexiblen Plugin oder bildbasierten Inputs können unsere Dienstleistungen zusammen mit jeder 3D-Designanwendung auf dem Markt genutzt werden.
                </Typography>
              </motion.div>
            </Box>
            <Box sx={{ flex: '1', width: '100%', maxWidth: { md: '50%' } }}>
              <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(2, 1fr)' },
                    gap: { xs: 4, sm: 5, md: 6 },
                    alignItems: 'center',
                    justifyItems: 'center',
                    padding: { xs: 2, sm: 3 }
                  }}>
                  {[
                    { src: sketchupLogo, alt: 'SketchUp' },
                    { src: revitLogo, alt: 'Autodesk Revit' },
                    { src: allplanLogo, alt: 'ALLPLAN' },
                    { src: vectorworksLogo, alt: 'Vectorworks' },
                    { src: archicadLogo, alt: 'ARCHICAD' },
                    { src: chiefarchitectLogo, alt: 'Chief Architect' }
                  ].map((logo, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}>
                      <Box
                        component='img'
                        src={logo.src}
                        alt={logo.alt}
                        sx={{
                          width: '100%',
                          maxWidth: { xs: '160px', sm: '180px', md: '200px' },
                          height: 'auto',
                          display: 'block',
                          objectFit: 'contain',
                          filter: 'grayscale(20%)',
                          opacity: 0.85,
                          transition: 'all 0.4s ease',
                          cursor: 'pointer',
                          '&:hover': {
                            filter: 'grayscale(0%)',
                            opacity: 1,
                            transform: 'scale(1.1)'
                          }
                        }}
                      />
                    </motion.div>
                  ))}
                </Box>
              </motion.div>
            </Box>
          </Box>
        </Container>
      </Box>
      */}

      {/* CTA Section */}
      <Box sx={{ py: { xs: 5, md: 7 }, backgroundColor: '#1a1a1a', textAlign: 'center' }}>
        <Container maxWidth='md'>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <Typography
              variant='h3'
              sx={{
                color: '#fff',
                fontWeight: 600,
                mb: 3,
                fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' }
              }}>
              Bereit für Ihr Projekt?
            </Typography>
            <Typography
              variant='body1'
              sx={{
                color: '#e0e0e0',
                mb: 5,
                maxWidth: '600px',
                mx: 'auto',
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.7
              }}>
              Lassen Sie uns zusammenarbeiten, um Ihre Vision mit präzisen CAD-Dienstleistungen zum Leben zu erwecken. Kontaktieren Sie uns noch heute für eine Beratung.
            </Typography>
            <Button
              variant='contained'
              size='large'
              href='/contact'
              sx={{
                px: 6,
                py: 2,
                fontSize: '1.1rem',
                backgroundColor: '#fff',
                color: '#000',
                '&:hover': {
                  backgroundColor: '#f0f0f0',
                  transform: 'scale(1.05)'
                },
                transition: 'all 0.3s ease'
              }}>
              Offerte anfordern
            </Button>
          </motion.div>
        </Container>
      </Box>
    </Layout>
  );
}

export default CADServices;
